<template>
    <div id="html-element" :class="{empty: !moduleData}">
        <div class="module" v-if="moduleData" :class="moduleData.Background + ' ' + moduleData.Spacing" :id="moduleData.AnchorID">
            <div class="container">
                <div class="head" v-if="moduleData.Title && moduleData.ShowTitle">
                    <p class="heading">{{moduleData.Title}}</p>
                </div>
                <div class="body">
                    <div class="blog-content">
                        <div class="content">
                            <div id="eveve-container" ref="bookingContainer">
                                <iframe data-id="nbi-widget" src="https://bookings.nowbookit.com/?accountid=710ee910-a096-4e7c-88ea-b1b8d68720f7&venueid=14287&theme=light&colors=hex,bd945b=transparent"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import {Glide, GlideSlide} from 'vue-glide-js';

    export default {
        name: "BookingElement",
        props: {
            component: {
                type: Object,
            }
        },
        data: {
            formLoaded: false
        },
        computed: {
            ...mapGetters(['getModuleData', 'getSettings']),
            moduleData() {
                return this.getModuleData(this.component.ID);
            }
        },
        updated() {
            const container = document.getElementById('eveve-container');
            const script = document.createElement('script');
            script.src = 'https://plugins.nowbookit.com/iframe-resizer-build/bundle.js';
            script.onload = () => {
                console.log('Library loaded');
            };
            container.appendChild(script);
        },
        /*updated() {
            if(!this.formLoaded) {
                this.addBookingFrame()
            }
        },*/
        methods: {
           /* addBookingFrame() {
                const eveveURL = 'https://nz.eveve.com/web/form?est=GibbstonValley';
                const container = document.getElementById('eveve-container');

                function insertForm(url) {
                    fetch(url).then(response => {
                        if (!response.ok) throw new Error('Booking server is not available');
                        return response.text();
                    }).then(content => {
                        container.innerHTML = content;
                        executeEmbeddedScripts(container);
                        if (typeof window.load === 'function') window.load();
                        else throw new Error('No load function');
                    }).catch(error => {
                        console.error('URL fetch failed', error);
                        container.innerHTML = '<h3>The booking service is temporarily unavailable, please try later</h3>';
                    });
                }

                function executeEmbeddedScripts() {
                    const scripts = container.getElementsByTagName('script');
                    for (let i = 0; i < scripts.length; i++) {
                        const script = document.createElement('script');
                        if (scripts[i].src) script.src = scripts[i].src;
                        else script.textContent = scripts[i].textContent;
                        document.body.appendChild(script);
                    }
                }

                insertForm(eveveURL);

                this.formLoaded = true
            }*/
        }

    }
</script>
